///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useHistory } from "react-router-dom";

import BidTags from "../../BidTags";
import getStatusColor from "../../../helpers/getStatusColor";
import { userRole } from "../../../helpers/types";
import { redirectToBid } from "../../../helpers/redirectToBid";

const BodyCell = ({ value, children, maxWidth, className }) => (
  <td
    className={`body-cell truncate py-8 px-8 align-middle ${className || ""}`}
    style={{ maxWidth: maxWidth }}
  >
    {value || children}
  </td>
);

function TableBody({ bids, user }) {
  const history = useHistory();

  const getAvatars = (avatars, maxAvatars) => (
    <>
      {avatars.slice(0, maxAvatars)}
      {avatars.length > maxAvatars && "..."}
    </>
  );

  return (
    <tbody data-testid="table-body">
      {bids.map(bid => (
        <tr
          className="row bg-white"
          key={bid.bidId}
          onClick={e => redirectToBid(e, bid.bidId, history)}
        >
          <BodyCell maxWidth="100px">
            <p
              style={{
                backgroundColor: getStatusColor(bid.status.label)
              }}
              className="status inline-block mb-0 mr-6"
            ></p>
            {bid.status.label}
          </BodyCell>
          <BodyCell value={bid.bidName} maxWidth="135px" />
          <BodyCell value={bid.shipperName} maxWidth="135px" />
          <BodyCell maxWidth="125px">
            {getAvatars(bid.activeBidAvatars, 4)}
          </BodyCell>
          <BodyCell value={bid.formattedDeadlineDate} maxWidth="75px" />
          <BodyCell value={bid.formattedStartDate} maxWidth="75px" />
          <BodyCell maxWidth="100px" className="text-right">
            {bid.laneCount}
          </BodyCell>
          <BodyCell maxWidth="160px">
            {(user.role === userRole.tlPricingAnalyst ||
              user.role === userRole.assetBasedPricingUser) &&
              getAvatars(bid.pricingRegionUsersAvatars, 5)}
          </BodyCell>
          <BodyCell
            value={bid.formattedLastChangeTime}
            maxWidth="72px"
            className="text-right"
          />
          <BodyCell maxWidth="190px">
            <BidTags bid={bid} user={user} />
          </BodyCell>
        </tr>
      ))}
    </tbody>
  );
}

export default TableBody;
